import styled from '@emotion/styled';
import { button, input, mainColors } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';

export const PersonalDetailsUniverseWrapper = styled('div', { label: 'PersonalDetailsUniverseWrapper' })`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const PersonalDetailsUniversePrefix = styled('div', { label: 'PersonalDetailsUniversePrefix' })`
    border: 1px solid ${input.borderColor};
    border-radius: 3px 0 0 3px;
    background: ${mainColors.grays.gray200};
    color: ${mainColors.grays.gray400};
    text-transform: uppercase;
    padding: 8px;
    font-weight: ${fontWeight.bold};
`;

export const PersonalDetailsCustomerID = styled('div', { label: 'PersonalDetailsCustomerID' })`
    border: 1px solid ${input.borderColor};
    width: 100%;
    border-radius: 0 3px 3px 0;
    padding: 8px;
    font-weight: ${fontWeight.bold};
    width: 100%;
`;

export const PersonalDetailsRowContainer = styled('div', { label: 'PersonalDetailsRowContainer' })`
    display: flex;
    margin-bottom: 12px;
`;

export const PersonalDetailsSuccessMessage = styled('div', { label: 'PersonalDetailsSuccessMessage' })`
    padding: 5px 10px;
    color: ${button.primary.txtColor};
    text-align: center;
    background-color: ${button.primary.ok.bgColor};
    height: 100%;
    font-weight: ${fontWeight.bold};
`;
